import React, { useEffect, useRef, useState } from "react";

const VoiceOption = ({ onSelect }) => {
	const [selectedTherapist, setSelectedTherapist] = useState(null);
	const currentAudio = useRef(null);

	const playAudio = (therapist) => {
		if (currentAudio.current) {
			currentAudio.current.pause();
			currentAudio.current.currentTime = 0;
		}

		const audio = new Audio(`/audio/${therapist.toLowerCase()}-intro.mp3`);
		currentAudio.current = audio;
		audio.play();
	};

	const handleSelect = (therapist) => {
		playAudio(therapist);
		setSelectedTherapist(therapist);
	};

	const handleContinue = () => {
		if (selectedTherapist && onSelect) {
			onSelect(selectedTherapist);
		}
	};

	useEffect(() => {
		return () => {
			if (currentAudio.current) {
				currentAudio.current.pause();
				currentAudio.current.currentTime = 0;
			}
		};
	}, []);

	return (
		<div className="w-full max-w-3xl backdrop-blur-lg rounded-3xl shadow-xl overflow-hidden flex flex-col bg-white">
			<div className="w-full text-center p-4">
				<h1 className="text-4xl font-normal text-blue-600 tracking-wide m-2 sm:m-4">
					milburn
				</h1>
				<div className="space-y-4 mb-4">
					<div className="text-gray-800 p-4">
						<p className="text-base sm:text-lg font-light whitespace-pre-line leading-relaxed mb-6">
							Choose your companion:
						</p>
						<div className="flex flex-col sm:flex-row gap-5 sm:gap-16 justify-center">
							<button
								onClick={() => handleSelect("Ruth")}
								className={`px-6 py-3 ${
									selectedTherapist === "Ruth"
										? "bg-green-500 text-white"
										: "bg-white text-green-500 border-2 border-green-500"
								} text-lg rounded-lg hover:bg-green-500 hover:text-white transition-all duration-300 shadow-md flex flex-col items-center`}>
								<span>Ruth</span>
							</button>
							<button
								onClick={() => handleSelect("Matthew")}
								className={`px-6 py-3 ${
									selectedTherapist === "Matthew"
										? "bg-purple-600 text-white"
										: "bg-white text-purple-600 border-2 border-purple-600"
								} text-lg rounded-lg hover:bg-purple-600 hover:text-white transition-all duration-300 shadow-md flex flex-col items-center`}>
								<span>Matthew</span>
							</button>
							<button
								onClick={() => handleSelect("Danielle")}
								className={`px-6 py-3 ${
									selectedTherapist === "Danielle"
										? "bg-pink-500 text-white"
										: "bg-white text-pink-500 border-2 border-pink-500"
								} text-lg rounded-lg hover:bg-pink-500 hover:text-white transition-all duration-300 shadow-md flex flex-col items-center`}>
								<span>Danielle</span>
							</button>
							<button
								onClick={() => handleSelect("Stephen")}
								className={`px-6 py-3 ${
									selectedTherapist === "Stephen"
										? "bg-blue-500 text-white"
										: "bg-white text-blue-500 border-2 border-blue-500"
								} text-lg rounded-lg hover:bg-blue-500 hover:text-white transition-all duration-300 shadow-md flex flex-col items-center`}>
								<span>Stephen</span>
							</button>
						</div>
						{selectedTherapist && (
							<div className="mt-8">
								<button
									onClick={handleContinue}
									className="px-8 py-3 bg-blue-500 text-white text-lg rounded-lg hover:bg-blue-600 transition-all duration-300 shadow-md">
									Continue
								</button>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default VoiceOption;
